
import ArticleComment from '../components/article-comment';

(function ($) {

  var maxArticleCommentLength = 1024;

  function stripTags(text) {
    return text.replace(/(<([^>]+)>)/ig, '');
  }

  function articleAnchorOnClick() {
    if (this.href.indexOf(requestContext.hostPath) === -1) {
      ux.traffic.custom('notify', 'mcx.help.article.external.click', [
        ['url', this.href],
        ['market', requestContext.market],
        ['inapp', gdhelp2.utils.inIframe()],
        ['internal', requestContext.internalRequest],
        ['plId', requestContext.plId]
      ]);
    }

    return true;
  }

  function setMTEnglishLink() {

    var link = $('#en-link');
    if (!link) {
      return;
    }

    var hash = document.location.hash || '';
    var qs = (document.location.search ?
      document.location.search + '&' : '?') + 'lang=en';

    link.attr('href', document.location.pathname + qs + hash);
  }

  function sendArticleImpression() {
    ux.traffic.custom('notify', 'mcx.help.article.impression', [
      ['referrer', document.referrer],
      ['market', requestContext.market],
      ['split', ''],
      ['inapp', gdhelp2.utils.inIframe()],
      ['internal', requestContext.internalRequest],
      ['qs', document.location.search.replace('?', '')],
      ['isTranslated', !!$('.article-rating-container').attr('data-mt')],
      ['plId', requestContext.plId]
    ]);
  }

  function bindArticleLinkClicks() {
    $('.article-container a').on('click', articleAnchorOnClick);
  }

  function bindMTAlertDismiss() {
    $('.alert-dismissable button[data-dismiss="alert"]').on('click', function () {
      $(this).closest('.alert').hide();
    });
  }

  function submitArticleComment(articleComment) {

    articleComment.alias = stripTags(articleComment.alias);
    articleComment.comments = stripTags(articleComment.comments);

    if (articleComment.comments.length > maxArticleCommentLength) {
      articleComment.comments = articleComment.comments.substr(0, maxArticleCommentLength);
    }

    if (articleComment.comments === 0) {
      return;
    }

    articleComment.articleId = $('#ticket-id').val();

    var articleCommentMsg = encodeURIComponent(JSON.stringify(articleComment));
    $.ajax({
      type: 'GET',
      url: requestContext.hostPath + '/ajax/internalComment?msg=' +
      articleCommentMsg,
      success: function () {
        location.reload();
      },
      error: function () {
        location.reload();
      }
    });
  }

  function initArticleComment() {
    var articleCommentElem = $('#article-comment-add');

    if (articleCommentElem.length) {
      ReactDOM.render(React.createElement(ArticleComment, {
        aliasLabel: 'Agent Alias',
        title: 'Comments for customers and internal users',
        commentLabel: 'Enter information others will find useful',
        submitFunction: submitArticleComment,
        submitLabel: 'Submit'
      }), articleCommentElem[0]);
    }
  }

  function ready() {
    if ($('.article-container').length) {
      sendArticleImpression();
      bindArticleLinkClicks();
      gdhelp2.utils.bindHelpVideoEvents();
      initArticleComment();
      bindMTAlertDismiss();
      setMTEnglishLink();

      if (typeof window.onHelpDataReady === 'function') {
        window.onHelpDataReady();
      }
    }
  }

  $(document).ready(ready);

}(jQuery));
